export default __webpack_public_path__ + "static/media/sw_1.1aef444f.png";